import { WidgetHandler } from '../../WidgetHandler';
import { callEventFunction } from './callEventFunction';
/**
 * Handles the widget's `onLoad` event by invoking the configured event function,
 * and optionally triggers `onChange` if `onLoadCallOnChange` is enabled in the config.
 *
 * @param {WidgetProps<any, any>} props - The widget props containing configuration and context.
 * @param {any} value - The current value to pass into the event handler functions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleWidgetOnLoad(props, value) {
    var _a;
    const handler = new WidgetHandler(props);
    callEventFunction(props, 'onLoad', 'value, handler', value, handler);
    if ((_a = props.config.event) === null || _a === void 0 ? void 0 : _a.onLoadCallOnChange) {
        callEventFunction(props, 'onChange', 'value, handler', value, handler);
    }
}
